export default {
  items: [
    {
      title: true,
      name: 'System'
    },
    {
      name: 'Templates',
      url: '/product/templates',
      icon: 'fa fa-puzzle-piece',
    },
    {
      name: 'Data points',
      url: '/product/data-points',
      icon: 'fa fa-table',
    },
    {
      name: 'Unique Attributes',
      url: '/product/uniqueattributes',
      icon: 'fa fa-tags',
    },
    {
      name: 'Unique Values',
      url: '/system/unique-values/',
      icon: 'fa fa-border-all',
    },
    {
      name: 'Manual input hints',
      url: '/manual-input-hints',
      icon: 'fa fa-hand-paper',
    },
    {
      name: 'Input',
      icon: 'fas fa-cloud-upload-alt',
      children: [
        {
          name: 'Templates',
          url: '/input/templates'
        },
        {
          name: 'Flows',
          url: '/input/input-flows'
        },
        {
          name: 'Ingested files',
          url: '/system/ingested-files',
        },
        {
          name: 'Channels',
          url: '/system/ingestion-channels',
        },
        {
          name: 'Direct outputs',
          url: '/system/direct-outputs',
        },
        {
          name: 'Data pulls',
          url: '/system/data-pulls',
        },
        {
          name: 'Webhooks',
          url: '/system/webhooks',
        }
      ]
    },
    {
      name: 'Output',
      icon: 'fas fa-cloud-download-alt',
      children: [
        {
          name: 'Templates',
          url: '/retailer/integrations'
        },
        {
          name: 'DDTs',
          url: '/retailer/templates'
        },
        // {
        //   icon: null,
        //   name: 'Automations',
        //   url: '/automations',
        // },
        {
          name: 'Sales data',
          url: '/system/outputs/sales-data-push-pipelines'
        },
        {
          name: 'Inventory data',
          url: '/system/outputs/inventory-data-push-pipelines'
        },
        {
          name: 'Google Drive connection',
          url: '/system/integrations/google'
        },
      ]
    },
    {
      name: 'Pipelines',
      url: '/pipelines',
      icon: 'fa fa-hand-paper',
    },
    {
      name: 'EDI',
      icon: 'fa fa-envelope',
      children: [
        {
          name: 'Overview',
          url: '/edi'
        },
        {
          name: 'Configuration',
          url: '/edi/configuration'
        },
        {
          name: 'Messages',
          url: '/edi/messages'
        }
      ]
    },
    {
      name: "Amazon",
      icon: 'fa-brands fa-amazon',
      children: [
        {
          name: 'Mapping',
          url: '/system/amazon/marketplaces',
        },
      ]
    },
    {
      name: "Shopify",
      icon: 'fa-brands fa-shopify',
      children: [
        {
          name: 'Client creds overrides',
          url: '/system/shopify/client-creds-overrides',
        },
      ]
    },
    {
      name: "Bol.com",
      icon: null,
      children: [
        {
          name: 'Mapping',
          url: '/system/bol/marketplaces',
        },
      ]
    },
    {
      icon: null,
      name: 'Magasin FTP Image processing',
      url: '/system/magasin-ftp-images',
    },
    {
      icon: null,
      name: 'Business Intelligence',
      url: '/business-intelligence',
    },
    {
      icon: 'fa fa-file-alt',
      name: 'Reports',
      url: '/reports',
    },

    {
      title: true,
      name: 'Clients & data',
    },
    {
      name: "Brands",
      url: "/brands",
      icon: 'fas fa-tshirt',
    },
    {
      name: "Retailers",
      url: "/retailers",
      icon: 'fa fa-store-alt',
    },
    {
      name: 'Companies',
      url: '/companies',
      icon: 'fas fa-building',
    },
    {
      name: 'Products',
      url: '/product/catalog',
      icon: 'fas fa-book-open',
    },
    {
      name: 'Orders',
      icon: 'fa fa-envelope',
      children: [
        {
          url: '/orders',
          name: 'Data'
        },
        {
          url: "/delivery-notes",
          name: "Delivery notes"
        },
        {
          url: '/order-sharing-policies',
          name: 'Sharing policies'
        },
      ],
    },
    {
      title: true,
      name: 'Others',
    },
    {
      name: 'OC parsers',
      url: '/parsers',
      icon: 'fa fa-clipboard-list'
    },
  ],
};
